import NavBarView from 'js/views/navbar.view';
import ServiceSuperView from 'js/views/service.super.view';
import ServicesView from 'js/views/services.view';
import UserModel from 'js/models/userrelatedinfo.model';
import i18n from 'l10n';
import dhtmlx from 'dhtmlxAdapter';
import {delegateEvent} from "../utils/event.delegator";
import {Backbone} from "backboneAdapter";


export default Backbone.Router.extend({
    routes: {
        ":id": "idRoute",
        "type/:svcId/status/:sts": "selectedRoute",
        "type/:svcId": "selectedRoute",
        "status/:sts": function(sts) {
            this.selectedRoute("all", sts);
        },
        "": "defaultRoute"
    },
    initialize: function (options) {
        const {isPostPaid} = options;
        this.isPostpaid = isPostPaid;
        this.umodel = new UserModel();
        this.umodel.bind("reset add remove", this.loadUser, this);
        this.loadUser();
        this.navbar = new NavBarView();
    },
    loadUser: function () {
        const self = this;
        this.umodel.fetch({
            success: function (data) {
                let expirationDate;
                if (data.get("expirationDate")) {
                    expirationDate = data.get("expirationDate").millis;
                } else {
                    expirationDate = i18n.t("never");
                }
                const subscriptionLevel = data.get("subscriptionLevel");
                self.showAppropriateInfo(expirationDate, subscriptionLevel);
            }
        });
    },
    showAppropriateInfo: function (expirationDate, subscriptionLevel) {
        const isRightLevel = subscriptionLevel > 0; //todo revisit this if subscription levels change
        const isNotExpired = (expirationDate && expirationDate !== i18n.t("never")) ?
            new Date(expirationDate) >= new Date() : true;
        if (!isNotExpired) {
            const title = "profile.nopermissiontitle";
            const text = "profile.nopermissiontext";
            const firstButton = "profile.nopermissionfirstbutton";
            this.modalBoxFun(title, text, firstButton);
        }
        if (!isRightLevel) {
            const title = "voucher.nopermissiontitle";
            const text = "voucher.nopermissiontext";
            const firstButton = "voucher.nopermissionfirstbutton";
            this.modalBoxFun(title, text, firstButton);
        }
    },
    modalBoxFun: function (titleText, textText, firstButton) {
        dhtmlx.modalbox({
            title: i18n.t(titleText),
            text: i18n.t(textText),
            buttons: [i18n.t(firstButton), i18n.t("cancelbtn")],
            callback: function (result) {
                if (result === "0") {
                    location.href = "Credits.htm";
                } else if (result === "1") {
                    location.href = "Dashboard.htm";
                }
            }
        });
    },
    selectedRoute: function (selectedSvc, selectedStatus) {
        if(!selectedSvc)
            selectedSvc = "all";
        if(!selectedStatus)
            selectedStatus = "all";

        this.removeAllEvents(this.serviceSuperView);
        this.removeAllEvents(this.servicesView);
        this.servicesView = new ServicesView();
        switch (selectedSvc) {
            case "vouchers":
                this.servicesView.vouchersCheckboxIsChecked = true;
                break;
            case "surveys":
                this.servicesView.surveysCheckboxIsChecked = true;
                break;
            case "optins":
                this.servicesView.optinsCheckboxIsChecked = true;
                break;
            case "vouchersAndSurveys":
                this.servicesView.vouchersCheckboxIsChecked = true;
                this.servicesView.surveysCheckboxIsChecked = true;
                break;
            case "vouchersAndOptins":
                this.servicesView.vouchersCheckboxIsChecked = true;
                this.servicesView.optinsCheckboxIsChecked = true;
                break;
            case "surveysAndOptins":
                this.servicesView.surveysCheckboxIsChecked = true;
                this.servicesView.optinsCheckboxIsChecked = true;
                break;
            default:
                this.servicesView.vouchersCheckboxIsChecked = true;
                this.servicesView.surveysCheckboxIsChecked = true;
                this.servicesView.optinsCheckboxIsChecked = true;
        }

        switch (selectedStatus) {
            case "active":
                this.servicesView.activeCheckboxIsChecked = true;
                break;
            case "ended":
                this.servicesView.endedCheckboxIsChecked = true;
                break;
            case "draft":
                this.servicesView.draftCheckboxIsChecked = true;
                break;
            case "activeAndEnded":
                this.servicesView.activeCheckboxIsChecked = true;
                this.servicesView.endedCheckboxIsChecked = true;
                break;
            case "activeAndDraft":
                this.servicesView.activeCheckboxIsChecked = true;
                this.servicesView.draftCheckboxIsChecked = true;
                break;
            case "draftAndEnded":
                this.servicesView.endedCheckboxIsChecked = true;
                this.servicesView.draftCheckboxIsChecked = true;
                break;
            default:
                this.servicesView.activeCheckboxIsChecked = true;
                this.servicesView.endedCheckboxIsChecked = true;
                this.servicesView.draftCheckboxIsChecked = true;
        }
        this.servicesView.setTemplateCollectionData();
    },
    idRoute: function (id) {
        this.removeAllEvents(this.servicesView);
        this.removeAllEvents(this.serviceSuperView);
        this.serviceSuperView = new ServiceSuperView(this.isPostpaid);
        this.navbar.off("changed:campaignStatus");
        delegateEvent(this.navbar, this.serviceSuperView, "changed:campaignStatus");
        this.serviceSuperView.load(id).catch(console.log);
    },
    defaultRoute: function () {
        this.navigate("type/all/status/all", true);
    },
    removeAllEvents: function (view) {
        if (view) {
            view.$el.off();
            view.$el.empty();
            view.undelegateEvents();
            view = null;
        }
    }
});
